import Moment from "moment";
import Attachment from "./Attachment";

const ViewComment = ({ comment }) => (
  <div className="mb-3 p-3 border rounded custom-input-color">
    <div className="d-flex justify-content-between mb-2 small text-muted">
      <div>
        <strong>Commented by :</strong> {comment.commentedByName}
      </div>
      <div>
 <strong>On :</strong>{" "}
{comment.createdDate
  ? Moment.utc(comment.createdDate).local().format("DD/MM/YYYY hh:mm A")
  : "-"}
      </div>
    </div>
    <div style={{ whiteSpace: "pre-wrap" }}>{comment.comment}</div>
    {comment.attachments?.length > 0 && (
      <div className="mt-3">
        <strong>Attachments:</strong>
        <div className="d-flex flex-wrap gap-3 mt-2">
          {comment.attachments.map((a, i) => (
            <Attachment key={i} no={i + 1} attachment={a} isComment />
          ))}
        </div>
      </div>
    )}
  </div>
);

export default ViewComment;
